// extracted by mini-css-extract-plugin
export var cartContainer = "_p9-4";
export var gray = "_p9-1";
export var itemContainer = "_p9-2";
export var itemDetails = "_p9-3";
export var strong = "_p9-0";